import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsCardRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-card',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/card',
	exact: true,
};
